export default function LaptopCheck({ size = '48', color = '#fff' }: { size?: string; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40 30.5V20.5M8 30.5V14.5C8 10.728 8 8.844 9.172 7.672C10.344 6.5 12.228 6.5 16 6.5H23M28 12.5C28 12.5 30 12.5 32 16.5C32 16.5 38.354 6.5 44 4.5M6.996 32.53L8.04 30.5H39.904L41.004 32.53C43.89 37.854 44.61 40.516 43.512 42.508C42.414 44.5 39.508 44.5 33.692 44.5H14.308C8.49 44.5 5.582 44.5 4.486 42.508C3.388 40.516 4.108 37.854 6.996 32.53Z"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 30.5V20.5M8 30.5V14.5C8 10.728 8 8.844 9.172 7.672C10.344 6.5 12.228 6.5 16 6.5H23M28 12.5C28 12.5 30 12.5 32 16.5C32 16.5 38.354 6.5 44 4.5M6.996 32.53L8.04 30.5H39.904L41.004 32.53C43.89 37.854 44.61 40.516 43.512 42.508C42.414 44.5 39.508 44.5 33.692 44.5H14.308C8.49 44.5 5.582 44.5 4.486 42.508C3.388 40.516 4.108 37.854 6.996 32.53Z"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
